import { useEffect } from 'react'
import { Trash2, X, XCircle } from 'lucide-react'

type Props = {
  // Sessions being removed, and the times each published one still to come
  // went to a phone's calendar.
  count: number
  calendarAdds: number[]
  place: string
  onCancelSessions: () => void
  onDelete: () => void
  onClose: () => void
}

const calendarLine = (count: number, adds: number[]) => {
  if (count === 1) {
    const people = adds[0] ?? 0
    if (!people) return 'Ninguém pôs este horário na agenda.'
    return people === 1 ? '1 pessoa pôs este horário na agenda.' : `${people} pessoas puseram este horário na agenda.`
  }
  const sessions = adds.filter(Boolean).length
  if (!sessions) return 'Ninguém pôs estes horários na agenda.'
  return sessions === 1 ? '1 destes horários está na agenda de alguém.' : `${sessions} destes horários estão na agenda de alguém.`
}

// A published session still to come that won't happen is canceled, as on
// Eventbrite: it leaves the app all the same, and who put it in their phone's
// calendar hears of it; deleting tells no one (PRD.md, item 107).
export function RemoveSessionsDialog({ count, calendarAdds, place, onCancelSessions, onDelete, onClose }: Props) {
  const one = count === 1

  useEffect(() => {
    const close = (event: KeyboardEvent) => { if (event.key === 'Escape') onClose() }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)
  }, [onClose])

  return (
    <div className="dialog-backdrop" role="presentation" onClick={onClose}>
      <section className="dialog dialog--compact" role="dialog" aria-modal="true" aria-labelledby="remove-sessions-title" onClick={(event) => event.stopPropagation()}>
        <div className="dialog__heading">
          <div>
            <h2 id="remove-sessions-title">{one ? 'Excluir horário?' : `Excluir ${count} horários?`}</h2>
            {place && <p><strong>{place}</strong></p>}
          </div>
          <button type="button" className="icon-button" aria-label="Fechar" onClick={onClose}><X size={18} /></button>
        </div>
        <div className="dialog__body">
          <p>{one
            ? 'Se ele não vai mais acontecer, cancele: o horário sai do app do mesmo jeito, e quem o pôs na agenda do celular é avisado.'
            : 'Se eles não vão mais acontecer, cancele: os horários saem do app do mesmo jeito, e quem os pôs na agenda do celular é avisado.'}</p>
          <p>{calendarLine(count, calendarAdds)}</p>
          <p>Excluir é só para horário cadastrado por engano, como uma data errada ou repetida: ninguém é avisado.</p>
        </div>
        <div className="dialog__actions">
          <button type="button" className="button button--secondary" onClick={onClose}>Voltar</button>
          <button type="button" className="button button--danger" onClick={onDelete}><Trash2 size={17} /> Excluir</button>
          <button type="button" className="button button--primary" onClick={onCancelSessions}><XCircle size={17} /> {one ? 'Cancelar horário' : 'Cancelar horários'}</button>
        </div>
      </section>
    </div>
  )
}
